import { FaTools  } from "react-icons/fa";
const TechnicalToolboxSectionComponent = () => {

  const technologies = ["Reactjs", "Redux", "Expressjs", "Nodejs", "MongoDB", "JQuery", "Javascript"]



  const textMute = () => {
    return "text-muted";
  };

  const technicalToolboxStyles = () => {
    return "badge bg-secondary";
  };
  
  return(
    <div className="mt-3">
      <FaTools size={28} className={textMute()}/>
      <h4 className={textMute()} style={{display: "inline"}}>&nbsp;TECHNICAL TOOLBOX</h4>
      <hr />
      <h5 className="mb-3">
        {technologies.map((technology, index) => {
          /* I learnt to create an empty space in JSX from: https://jsfiddle.net/omerts/b4st33nw/ */
          return <span key={index}><span className={technicalToolboxStyles()} key={index}>{technology}</span>{'\u00A0'}</span>;
        })}
      </h5>
    </div>
  );
};
export default TechnicalToolboxSectionComponent;